import script from "./problemRelation.vue?vue&type=script&setup=true&lang=js"
export * from "./problemRelation.vue?vue&type=script&setup=true&lang=js"

import "./problemRelation.vue?vue&type=style&index=0&id=763a35c8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-763a35c8"]])

export default __exports__